import classnames from 'classnames'
import type { FC } from 'react'
import { useTheme } from '@opallabs/hooks'
import { Position } from '../../gem'
import * as styles from './styles'
import type { InputLabelProps } from './types'

export type { InputLabelProps }

export const InputLabel: FC<React.PropsWithChildren<InputLabelProps>> = ({
  id,
  children,
  childrenPosition = Position.End,
  className,
  disabled = false,
  inputId,
  modified = false,
  required = false,
  styleOverrides,
  text,
  theme: propTheme,
  valid = false,
}) => {
  const providedTheme = useTheme()
  const theme = propTheme ?? providedTheme

  return (
    <label
      id={id}
      css={[styles.label({ theme }), styleOverrides]}
      className={classnames(['lapidary-input-label', className])}
      aria-disabled={disabled}
      data-required={required}
      data-valid={!(modified && required && !valid)}
      htmlFor={inputId}
    >
      {childrenPosition === Position.Start && children}

      {text}

      {childrenPosition === Position.End && children}
    </label>
  )
}
InputLabel.displayName = 'Lapidary: InputLabel'
